import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {handleError} from '../../shared/util/error-util';
import {LogErroModel} from './log-erro-model';
import * as Process from "process";
import {Processamento} from "../processamento/processamento";
import {DatePipe} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class LogErroService {

  constructor(
    private readonly datePipe: DatePipe,
    private readonly httpclient: HttpClient) {
  }
  private readonly _httpHeaders = new HttpHeaders({'Content-Type': 'application/json'});

  search(idCarteira: number): Observable<LogErroModel> {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    return this.httpclient.get<LogErroModel>("/v1/logs/carteira/" + idCarteira, {headers}).pipe(catchError(handleError));
  }

  exportTxt(idCarteira: number, processamento: Processamento ): Observable<HttpResponse<ArrayBuffer>> {
    const headers = this._httpHeaders;
    const params = this.createFormParam(processamento);

    return this.httpclient
      .get<ArrayBuffer>("/v1/logs/export/" + idCarteira , {
        headers,
        observe: 'response',
        params,
        responseType: 'blob' as 'json'
      })
      .pipe(catchError(handleError));
  }


  private createFormParam(value: any) {

    let params: HttpParams = new HttpParams();
    if (value.carteira && value.carteira !== '') {
      params = params.set('carteira', value.carteira);
    }
    if (value.ultimaDataProcessamento) {
      params = params.set('ultimaDataProcessamento', this.datePipe.transform(value.ultimaDataProcessamento, 'yyyy-MM-dd'));
    }
    return params;
  }
}
